import * as t from 'io-ts'

export const fieldAnnotationCodec = t.intersection([
  t.type({ description: t.string }),
  t.partial({
    examples: t.array(t.unknown),
    relatesTo: t.string,
  }),
])

export const collectionAnnotationCodec = t.intersection([
  t.type({ description: t.string }),
  t.partial({
    fields: t.record(t.string, fieldAnnotationCodec),
    readOnly: t.boolean,
    tags: t.array(t.string),
  }),
])

/** The shape of the import file: { [tableName]: CollectionAnnotation } */
export const importFileCodec = t.record(t.string, collectionAnnotationCodec)

export const orcaQueryFieldAnnotationCodec = t.intersection([
  t.type({ type: t.string, description: t.string }),
  t.partial({
    unit: t.string,
    examples: t.array(t.unknown),
    relatesTo: t.string,
  }),
])

export const orcaQueryTagAnnotationCodec = t.type({ description: t.string })

/**
 * One saved query in an import/export file. Extra fields (name, resolvedAt, …)
 * on exported objects are tolerated by io-ts and ignored on import.
 */
export const orcaQueryImportCodec = t.intersection([
  t.type({
    description: t.string,
    tags: t.array(t.string),
    fields: t.record(t.string, orcaQueryFieldAnnotationCodec),
    observedTags: t.record(t.string, orcaQueryTagAnnotationCodec),
  }),
  t.partial({ name: t.string }),
])

/** The shape of the query import/export file: { [queryName]: query }. */
export const orcaQueryImportFileCodec = t.record(t.string, orcaQueryImportCodec)
